import MaterialAvatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React__default from 'react';
import { stringToColor, extractInitials } from './utils.esm.js';
import classNames from 'classnames';

const useStyles = makeStyles(
  (theme) => ({
    avatar: {
      width: "4rem",
      height: "4rem",
      color: theme.palette.common.white,
      backgroundColor: (props) => props.backgroundColor
    },
    avatarText: {
      fontWeight: theme.typography.fontWeightBold,
      letterSpacing: "1px",
      textTransform: "uppercase"
    }
  }),
  { name: "BackstageAvatar" }
);
function Avatar(props) {
  const { displayName, picture, customStyles } = props;
  const styles = { ...customStyles };
  const fontStyles = {
    fontFamily: styles.fontFamily,
    fontSize: styles.fontSize,
    fontWeight: styles.fontWeight
  };
  const classes = useStyles(
    !picture ? { backgroundColor: stringToColor(displayName || "") } : {}
  );
  const avatarClassNames = classNames(props.classes?.avatar, classes.avatar);
  const avatarTextClassNames = classNames(
    props.classes?.avatarText,
    classes.avatarText
  );
  return /* @__PURE__ */ React__default.createElement(
    MaterialAvatar,
    {
      alt: displayName,
      src: picture,
      className: avatarClassNames,
      style: styles
    },
    displayName && /* @__PURE__ */ React__default.createElement(
      Typography,
      {
        variant: "h6",
        component: "span",
        className: avatarTextClassNames,
        style: fontStyles
      },
      extractInitials(displayName)
    )
  );
}

export { Avatar };
//# sourceMappingURL=Avatar.esm.js.map
